import DeviceService from '@/modules/core/ui/services/DeviceService';

export const ResponsiveMixin = {
  computed: {
    isMobile() {
      return DeviceService.isMobile();
    }
  }
};
